var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-result", {
    staticClass: "error-page",
    attrs: {
      status: "500",
      title: "500",
      "sub-title": _vm.$t("对不起，服务器出问题了")
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function () {
        return [_c("a-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: _vm.returnHome
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("返回首页")) + " ")])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };